<template>
  <div>
    <section class="tasks">
      <div class="input-group">
        <v-row :class="{ 'no-gutters': noGutters }">
          <v-col cols="12" :class="{ 'pb-2': noGutters }">
            <validation-provider ref="checkList" name="unimed" mode="eager">
              <autocomplete-cadu
                :errorMessage="error"
                :items="listaFiltro"
                :itemText="itemTextFiltro"
                :placeholder="placeholder"
                :title="titulo"
                :disabled="disabled"
                v-model="newTask"
                @index="addTask"
                @blur="blurAuto"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </div>
      <v-container fluid class="pl-0 pr-0 pt-0 pb-0" fill-height>
        <v-layout wrap>
          <div class="tasks__list" :class="overflow ? 'scroll' : 'sem-scroll'">
            <v-chip
              :key="index"
              v-for="(task, index) in tasks"
              text-color="green"
              color="green"
              :outlined="true"
              :class="classChips"
            >
              &nbsp;
              <div v-if="task.title.length < lengthSize">
                {{ task.title }}
              </div>
              <div v-else>
                {{ task.title.substring(0, lengthSize - 2) + '...' }}
              </div>
              <button-rounded
                v-if="!disabled"
                :closeIcon="true"
                @click="removeTask(index)"
                iconName="x"
                :iconSize="15"
              />
            </v-chip>
          </div>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
import { find } from 'lodash'
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider
  },
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    listaFiltro: {
      type: Array,
      default: () => [],
      required: true
    },
    itemTextFiltro: {
      type: String,
      default: '',
      required: true
    },
    titulo: {
      type: String,
      default: '',
      required: false
    },
    noGutters: {
      type: Boolean,
      default: false
    },
    overflow: {
      type: Boolean,
      default: false
    },
    lengthSize: {
      type: Number,
      default: 40
    },
    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newTask: {},
      indexTask: -1,
      error: ''
    }
  },
  methods: {
    blurAuto() {
      if (this.required && this.tasks.length === 0) {
        this.error = 'error'
      }
    },
    async verifyError() {
      if (this.tasks.length <= 0) {
        this.error = 'error'
      } else {
        this.error = ''
        await this.$refs.checkList.reset()
      }
      return this.tasks.length <= 0
    },
    async addTask(index) {
      this.error = ''
      await this.$nextTick()
      this.indexTask = index
      if (this.newTask) {
        let obj = {
          title: this.newTask[this.itemTextFiltro],
          id: this.listaFiltro[this.indexTask].id
        }
        let taskFind = find(this.tasks, obj)

        if (!taskFind) {
          this.tasks.push(obj)
        }
        this.newTask = {}
      }
    },
    removeTask(index) {
      this.tasks.splice(index, 1)
    },
    async clearAll() {
      this.$emit('filtradas', [])
      this.newTask = {}
      await this.$nextTick()
      this.error = ''
      await this.$refs.checkList.reset()
    },
    inputTask(input) {
      if (input) {
        this.newTask = input
      }
    }
  },

  watch: {
    tasks() {
      this.$emit('filtradas', this.tasks)
    }
  },

  computed: {
    classChips() {
      return this.disabled ? 'mb-2 mr-1 pr-4' : 'mb-2 mr-1 pr-1'
    }
  }
}
</script>

<style lang="sass">
.fade-enter-active, .fade-leave-active
  transition: opacity .5s

.fade-enter, .fade-leave-active
  opacity: 0

.input-group-button
    margin-top: 15px

.tasks__list
  width: 100%

.scroll
  max-height: 120px
  overflow: hidden auto

.sem-scroll
  overflow: hidden
</style>
